import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { taskManagerContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import getDollarValueOfToken from "../../services/tokenPrice_usd";

const CreateTast = () => {

  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.tastManager;
  const contract = taskManagerContract(tokenAddress, web3);

  const createTast = useCallback(
    async (createTask, title, description, token, decimal, disputeType) => {
      
      
      try {
        let gasFunPrice;
        let amount2;
        let amount;
        console.log(createTask, title, description, token, decimal, disputeType, "create task payload...11");

        if (decimal === 18) {
          amount = web3.utils.toWei(createTask?.toString(), 'ether');
        } else if (decimal === 6) {
          amount = web3.utils.toWei(createTask.toString(), 'mwei');
        } else {
          amount = parseFloat(createTask) * Math.pow(10, parseInt(decimal));
        }

        amount2 = (token === Environment?.ETH) ? amount : 0;

        


        console.log(title, description, amount, token, disputeType, "create task payload.... 222");
   
        web3.eth.getGasPrice().then((result) => {
          var result2 = parseInt(result)
          gasFunPrice = result2.toString()
        })

        const gas = await contract.methods.createTask(title, description, amount, token, disputeType).estimateGas({
          from: account,
          value: amount2
        });

        const details = await contract.methods.createTask(title, description, amount, token, disputeType).send({
          from: account,
          gas,
          gasPrice: gasFunPrice,
          value: amount2
        });

        return details;
      } catch (error) {
        console.log(error, 'errorerror');
        throw error;
      }
    },
    [contract, account]
  );

  return { createTast: createTast };
};
export default CreateTast;